import React from 'react';
import { Button } from './ui/button';
import { Phone, Mail, MessageCircle } from 'lucide-react';
import { companyInfo } from '../data/mock';

const CTA = () => {
  return (
    <section className="py-20 bg-white">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="bg-gradient-to-r from-[#1a365d] to-[#2d5a9e] rounded-3xl p-8 md:p-12 relative overflow-hidden">
          {/* Background Pattern */}
          <div className="absolute inset-0 opacity-10">
            <div className="absolute top-0 right-0 w-64 h-64 bg-white rounded-full translate-x-1/2 -translate-y-1/2"></div>
            <div className="absolute bottom-0 left-0 w-48 h-48 bg-white rounded-full -translate-x-1/2 translate-y-1/2"></div>
          </div>

          <div className="relative z-10 text-center">
            <h2 className="text-3xl sm:text-4xl font-bold text-white mb-4">
              Ready to Clear the Clutter?
            </h2>
            <p className="text-white/80 text-lg mb-8 max-w-xl mx-auto">
              Get a free quote in minutes. No obligations, no hidden fees — just honest pricing.
            </p>

            {/* Contact Options */}
            <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
              <a
                href={`tel:${companyInfo.phone}`}
                className="flex items-center space-x-3 bg-white text-[#1a365d] font-semibold px-8 py-4 rounded-xl hover:bg-blue-50 transition-colors shadow-lg"
              >
                <Phone className="h-5 w-5" />
                <span>Call {companyInfo.phone}</span>
              </a>
              <a
                href={`mailto:${companyInfo.email}`}
                className="flex items-center space-x-3 bg-white/10 text-white font-semibold px-8 py-4 rounded-xl hover:bg-white/20 transition-colors border border-white/30"
              >
                <Mail className="h-5 w-5" />
                <span>Email Us</span>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTA;
